export const GET_ACTION_PAGE_INIT = 'GET_ACTION_PAGE_INIT';
export const GET_ACTION_PAGE_SUCCESS = 'GET_ACTION_PAGE_SUCCESS';
export const GET_ACTION_PAGE_FAILURE = 'GET_ACTION_PAGE_FAILURE';
export const GET_HIDDEN_ACTION_PAGE_FAILURE = 'GET_HIDDEN_ACTION_PAGE_FAILURE';
export const SEND_PARTICIPATION_DATA_INIT = 'SEND_PARTICIPATION_DATA_INIT';
export const SEND_PARTICIPATION_DATA_SUCCESS = 'SEND_PARTICIPATION_DATA_SUCCESS';
export const SEND_PARTICIPATION_DATA_FAILURE = 'SEND_PARTICIPATION_DATA_FAILURE';

export const SET_PARTICIPATION_DIALOG_OPEN = 'SET_PARTICIPATION_DIALOG_OPEN';